module.exports = __webpack_public_path__ + "static/media/search-button.8b50c96a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wcce/search-button.svg
// module id = 962
// module chunks = 0